import { Phone } from "../../src/components/phoneUI/PhoneClass";
import { Node } from "../../src/shell/Actions/Action";
import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { emily } from "../characters/Emily";
import { empty } from "../characters/empty";
import { jenny } from "../characters/Jenny";
import { joe } from "../characters/Joe";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { doSmsSound, doTransition, doWaitImageByTime } from "../helpers/helpers";
import { extras, images } from "./images";
import { V7_JennyJoeRivalBarAfter } from "./V7";

export const V7_JennyJoeRivalBar = async (): Promise<any> => {
    doSmsSound();
    await Phone.showMessagesUI({ name: vanessa.name, profileImage: extras.VanessaProfilePic2 }, async () => {
        Phone.setMessage({ character: vanessa.character, text: `PICK ME UP NOW`, options: { wait: false } });
        Phone.setMessage({ character: mc.character, text: `What happened?` });
        Phone.setMessage({ character: vanessa.character, text: `FAST I GOTTA CHECK SOMETHING.` });
        Phone.setMessage({ character: vanessa.character, text: `Fine, OMW.` });
        Phone.closeMessagesUI();
    });


    return jump(V7_JennyJoeRivalBar_Bar, "V7_JennyJoeRivalBar_Bar");
};
export const V7_JennyJoeRivalBar_Bar = async (): Promise<any> => {
    doTransition(images.v7.V7JennyJoeRivalBar_0);
    vanessa.talk(`I knew it!`);
    mc.think(`Isn't that the girl I saw with Joey at the beach when I was with Emily?`);
    mc.think(`I'm sure of it!`);
    vanessa.talk(`I'm gonna kill him!`);
    if (Question.globalAnswers.v6EmilyAfterJoeRivalConvAllowDatingJoe) {
        mc.think(`I just gave Emily my blessing to start dating him and he's already seeing someone else?`);
        mc.think(`Or maybe it really was an innocent dinner...?`);

    }
    doWaitImageByTime(images.v7.V7JennyJoeRivalBar_2);
    vanessa.talk(`Hello, I'm Vanessa, what can I get for you?`);
    jenny.talk(`Hey! I'm Jenny. We already got our drinks thank you!`);
    joe.talk(`Fuck.`);
    ImageClass.setImage(images.v7.V7JennyJoeRivalBar_1);
    vanessa.talk(`Are you sure? Maybe a snack? Some pickles? a new GIRLFRIEND?`);
    ImageClass.setImage(images.v7.V7JennyJoeRivalBar_3);
    jenny.talk(`Ah... What's going on?`);
    ImageClass.setImage(images.v7.V7JennyJoeRivalBar_4);
    vanessa.talk(`This little weasel is my soon to be ex-boyfriend.`);
    ImageClass.setImage(images.v7.V7JennyJoeRivalBar_3);
    jenny.talk(`I'm sorry! I had no idea.`);
    ImageClass.setImage(images.v7.V7JennyJoeRivalBar_5);
    joe.talk(`Honey! It's not what it look like!`);
    vanessa.talk(`It's exactly what it looks like! We said no cheating without asking for approval.`);
    joe.talk(`You did it first.`);
    vanessa.talk(`It's not the same I had no choice!`);
    vanessa.talk(`I'm out of here!`);
    doWaitImageByTime(images.v7.V7JennyJoeRivalBar_6);
    mc.think(`They left... That was awkward...`);

    ImageClass.setImage(images.v7.V7JennyJoeRivalBar_7);
    await jenny.setQuestion(new Question({ text: `I have no idea what just happened...`, options: { think: false }, key: `v7JoeRivalCheckedOutJenny` })
        .option({ title: `Check her out`, key: true })
        .option({ title: `Don't check her out`, key: false }));


    if (Question.globalAnswers.v7JoeRivalCheckedOutJenny) {

        doWaitImageByTime(images.v7.V7JennyJoeRivalBar_9);
        mc.think(`Damn... Very nice.`);
        ImageClass.setImage(images.v7.V7JennyJoeRivalBar_7);
    }

    mc.talk(`That's fine... Their relationship are complicated.`);
    jenny.talk(`I had no idea he is taken.`);
    mc.talk(`I believe you.`);

    await mc.setQuestion(new Question({ text: `If you excuse me, I'll have to try and catch a cab since my ride just left...`, options: { think: false }, key: `v7JoeRivalOfferJennyRide` })
        .option({ title: `Offer her a ride`, key: true })
        .option({ title: `Let her leave`, key: false }));

    if (Question.globalAnswers.v7JoeRivalOfferJennyRide) {
        await mc.set((properties) => {
            properties.hasJennysNumber = true;
            properties.jennyRelationship += 2;
        });
    } else {
        mc.talk(`Good night.`);
        return jump(V7_JennyJoeRivalBar_End, "V7_JennyJoeRivalBar_End");
    }

    mc.talk(`It's late, let me give you a ride.`);
    ImageClass.setImage(images.v7.V7JennyJoeRivalBar_7.partials.V7JennyJoeRivalBar_8_p);
    jenny.talk(`Thank you but I don't even know your name.`);
    mc.talk(`My name is ${mc.name} and I'll be your ride for this evening.`);
    ImageClass.setImage(images.v7.V7JennyJoeRivalBar_10);
    jenny.talk(`I don't know...`);
    mc.talk(`I insist.`);
    ImageClass.setImage(images.v7.V7JennyJoeRivalBar_10.partials.V7JennyJoeRivalBar_11_p);
    jenny.talk(`Ah...`);
    ImageClass.setImage(images.v7.V7JennyJoeRivalBar_7.partials.V7JennyJoeRivalBar_8_p, { putParent: true });
    jenny.talk(`Alright! Only if it's not too much trouble.`);
    mc.talk(`It's not.`);
    mc.talk(`Let's go, my car is outside.`);
    doTransition(images.v7.V7JennyJoeRivalBar_12);
    jenny.talk(`You have a... Unique taste.`);
    mc.talk(`Yeah... That's my ${emily.properties.relation}'s car.`);
    jenny.talk(`Haha, I could've guessed.`);
    doTransition(images.v7.V7JennyJoeRivalBar_13);
    mc.talk(`Here we are.`);
    jenny.talk(`Thank you! I really appreciate it.`);
    mc.talk(`I hope I could make this night a bit better.`);
    jenny.talk(`You did!`);

    // TODO: more renders for this conv below
    mc.talk(`But I feel like something is still missing...`);
    ImageClass.setImage(images.v7.V7JennyJoeRivalBar_13.partials.V7JennyJoeRivalBar_16_p);
    jenny.talk(`What's that?`);
    mc.talk(`Your number.`);
    ImageClass.setImage(images.v7.V7JennyJoeRivalBar_13.partials.V7JennyJoeRivalBar_15_p);
    jenny.talk(`Haha.`);
    ImageClass.setImage(images.v7.V7JennyJoeRivalBar_13.partials.V7JennyJoeRivalBar_16_p);
    jenny.talk(`Tell me yours, I'll write it down.`);
    mc.talk(`I know that trick...`);
    jenny.talk(`I'll text you, I promise.`);
    ImageClass.setImage(images.v7.V7JennyJoeRivalBar_17);
    mc.talk(`Alright, my number is: 91-2123-344.`);
    jenny.talk(`Got it!`);
    ImageClass.setImage(images.v7.V7JennyJoeRivalBar_17.partials.V7JennyJoeRivalBar_18_p);
    jenny.talk(`Thanks again! Good night!`);

    return jump(V7_JennyJoeRivalBar_End, "V7_JennyJoeRivalBar_End");
};

export const V7_JennyJoeRivalBar_End = async (): Promise<any> => {

    return jump(V7_JennyJoeRivalBarAfter, "V7_JennyJoeRivalBarAfter");
};